module.exports = __webpack_public_path__ + "img/notification.778022cb.svg";